import uuid from 'uuid'

import { STORAGE_DATA } from '@/constants/storageData'

// 推薦區塊（與 shop-api service/product_recommend RecSources 一致）：推薦商品的連結帶 ?rec=區塊，
// 商品頁記錄瀏覽時一起送給後端，後台「推薦成效」用來算各區塊的點擊與成交
export const REC_SOURCE = {
  PRODUCT_RELATED: 'product_related', // 商品頁：也買了 / 看了也看 / 你可能也喜歡
  PRODUCT_HOT: 'product_hot', // 商品頁：熱門商品
  CART: 'cart',
  FOR_YOU: 'for_you',
  RECENTLY_VIEWED: 'recently_viewed',
  HOME_HOT: 'home_hot',
  MAIL: 'mail', // 行銷信件的商品連結 ?rec=mail
  MAIL_RECOMMEND: 'mail_recommend', // 行銷信件的個人推薦 ?rec=mail_recommend
} as const

export type RecSource = (typeof REC_SOURCE)[keyof typeof REC_SOURCE]

const REC_SOURCES = Object.values(REC_SOURCE) as string[]

export const isRecSource = (value: unknown): value is RecSource => typeof value === 'string' && REC_SOURCES.includes(value)

// 訪客 id：存在瀏覽器，登入前後都帶，讓未登入的「最近看過」與登入前看過的商品接得起來；無法存取 storage 時回空字串
export const getVisitorId = (): string => {
  if (typeof window === 'undefined') return ''
  try {
    let id = localStorage.getItem(STORAGE_DATA.VISITOR_ID)
    if (!id) {
      id = uuid.v4()
      localStorage.setItem(STORAGE_DATA.VISITOR_ID, id)
    }
    return id
  } catch {
    return ''
  }
}

// 這次進商品頁是不是從推薦點進來的：推薦區塊的商品卡與行銷信件的連結都會帶 ?rec=區塊
export const recSourceFromQuery = (queryRec: unknown): RecSource | undefined => (isRecSource(queryRec) ? queryRec : undefined)
